import { Route } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { authGuard } from './core/guards/auth/auth.guard';
import { CacheManagementComponent } from './features/cache-management/cache-management.component';
import { CitiesComponent } from './features/cities/cities.component';
import { CompetencesComponent } from './features/competences/competences.component';
import { ContactManagementComponent } from './features/contact-management/contact-management.component';
import { FileManagementComponent } from './features/file-management/file-management.component';
import { ImportProfilesComponent } from './features/import-profiles/import-profiles.component';
import { M2mTokensComponent } from './features/m2m-tokens/m2m-tokens.component';
import { CompetenceI18nComponent } from './features/competence-i18n/competence-i18n.component';
import { MigrationsComponent } from './features/migrations/migrations.component';
import { PortalsComponent } from './features/portals/portals-container/portals.component';
import { RegionsComponent } from './features/regions/regions.component';
import { VacancyMaintenanceComponent } from './features/vacancy-maintenance/vacancy-maintenance.component';
import { LayoutComponent } from './shared/components/layout/layout.component';

export const appRoutes: Route[] = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'portals',
        pathMatch: 'full',
      },
      {
        path: 'portals',
        component: PortalsComponent,
      },
      {
        path: 'cities',
        component: CitiesComponent,
      },
      {
        path: 'regions',
        component: RegionsComponent,
      },
      {
        path: 'competences',
        component: CompetencesComponent,
      },
      {
        path: 'import-profiles',
        component: ImportProfilesComponent,
      },
      {
        path: 'migrations',
        component: MigrationsComponent,
      },
      {
        path: 'competence-i18n',
        component: CompetenceI18nComponent,
      },
      {
        path: 'cache-management',
        component: CacheManagementComponent,
      },
      {
        path: 'file-management',
        component: FileManagementComponent,
      },
      {
        path: 'contact-management',
        component: ContactManagementComponent,
      },
      {
        path: 'vacancy-maintenance',
        component: VacancyMaintenanceComponent,
      },
      {
        path: 'm2m-tokens',
        component: M2mTokensComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
